module.exports = __webpack_public_path__ + "assetname.d2de633.png";